import { apiRequest } from './client';
import type { DeviceShareRepository } from '../../application/ports/DeviceShareRepository';
import type { DeviceShare, PendingQrInvite, ShareLevel, AcceptedInvite } from '../../domain/DeviceShare';

export class HttpDeviceShareRepository implements DeviceShareRepository {
  listShares(deviceId: string) {
    return apiRequest<{ shares: DeviceShare[]; pendingQrInvite: PendingQrInvite | null }>(`/devices/${deviceId}/shares`);
  }

  inviteByEmail(deviceId: string, email: string, level: ShareLevel) {
    return apiRequest<{ share: { userId: string; userName: string; userEmail: string; level: ShareLevel } }>(
      `/devices/${deviceId}/shares`,
      { method: 'POST', body: JSON.stringify({ email, level }) }
    );
  }

  revokeShare(deviceId: string, shareId: string) {
    return apiRequest<void>(`/devices/${deviceId}/shares/${shareId}`, { method: 'DELETE' });
  }

  createQrInvite(deviceId: string, level: ShareLevel) {
    return apiRequest<{ token: string; level: ShareLevel; expiresAt: string }>(`/devices/${deviceId}/shares/qr`, {
      method: 'POST',
      body: JSON.stringify({ level }),
    });
  }

  acceptInvite(token: string) {
    return apiRequest<AcceptedInvite>('/device-shares/accept', {
      method: 'POST',
      body: JSON.stringify({ token }),
    });
  }
}
